import { render, staticRenderFns } from "./programCard.vue?vue&type=template&id=e5fc5b36&"
import script from "./programCard.vue?vue&type=script&lang=js&"
export * from "./programCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports